import { render, staticRenderFns } from "./Relays.vue?vue&type=template&id=3cd3404e&"
import script from "./Relays.vue?vue&type=script&lang=js&"
export * from "./Relays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports